export const SIDEBAR_COLLAPSED = false
export const SIDEBAR_EXPANDED = true
